import React, { useEffect } from 'react';
import { IProduct } from '../../../../../utils/types/contentful';
import {
  ProductMainVariantDetailsHeader,
  ProductMainVariantDetailsHeaderProductPrice,
} from './Header/productMainVariantDetailsHeader';
import { ProductPackMainRecommendations } from './Recommendations/productPackMainRecommendations';
import { formatContentfulComponentProps } from '../../../../../utils/globals/index';
import { BuyProductPackButton } from '../../../BuyButton/buyProductPack';
import { ProductMainVariantDetailsInfos } from './Infos/productMainDetailsInfos';
import { useMediaQuery } from '../../../../../utils/hooks/useMediaQuery';
import { ProductMainSubHeader } from './SubHeader/productMainSubHeader';
import { useResetRecoilState, useSetRecoilState } from 'recoil';
import { SubHeaderState } from '../../../../../utils/recoil/subHeader';

export interface ProductMainVariantDetailsProps {
  product: IProduct;
}

export const ProductPackDetails: React.FC<ProductMainVariantDetailsProps> = ({
  addToCartButtons,
  product,
  recommendation,
  productPackOptionList,
  productPackPicker,
}) => {
  const setSubHeader = useSetRecoilState(SubHeaderState);
  const resetSubHeader = useResetRecoilState(SubHeaderState);

  const isWindowSmallSize = useMediaQuery('lg');
  const category = product.categories && product.categories[0];
  const shopifyVariants = product.fields.shopifyData.variants;

  useEffect(() => {
    setSubHeader({
      children: (
        <ProductMainSubHeader
          button={returnBuyButton()}
          price={headerPrice}
        />
      ),
      placement: isWindowSmallSize ? 'bottom' : 'top',
      isDefaultScroll: isWindowSmallSize,
    });
    return () => {
      resetSubHeader();
    };
  }, [isWindowSmallSize]);

  const returnBuyButton = () => (
    <BuyProductPackButton
      productPackPicker={productPackPicker}
      productPackOptionList={productPackOptionList}
      shopifyKey={product.shopifyKey}
      color={category?.color}
      buttons={formatContentfulComponentProps(addToCartButtons)}
    />
  );

  const headerPrice = (
    <ProductMainVariantDetailsHeaderProductPrice
      shopifyVariants={shopifyVariants}
      category={category}
    />
  );

  return (
    // The responsibility of displaying the components is shared between ProductPackMain and ProductPackDetails
    <div className='w-full'>
      <ProductMainVariantDetailsHeader
        category={category}
        label={product.label}
        subLabel={product.subLabel}
        shopifyVariants={shopifyVariants}
      />
      {addToCartButtons && !isWindowSmallSize && (
        <div className='my-4'>
          <BuyProductPackButton
            productPackPicker={productPackPicker}
            productPackOptionList={productPackOptionList}
            shopifyKey={product.shopifyKey}
            color={category?.color}
            buttons={formatContentfulComponentProps(addToCartButtons)}
          />
        </div>
      )}
      {/* Display ProductPackMainRecommendations for desktop (responsive in ProductPackMain) */}
      {product.recommendations && !isWindowSmallSize && (
        <ProductPackMainRecommendations
          {...formatContentfulComponentProps(recommendation)}
          recommendations={product.recommendations}
        />
      )}
      {/* Display ProductMainVariantDetailsInfos for desktop (responsive in ProductPackMain) */}
      {!isWindowSmallSize && (
        <ProductMainVariantDetailsInfos informations={product.informations} />
      )}
    </div>
  );
};
